import isEqual from "lodash/isEqual";
import { Node as ProseMirrorNode } from "prosemirror-model";
import { Plugin } from "prosemirror-state";
import { findChildrenByType } from "prosemirror-utils";
import { getTocJSON } from "./commands";
export function TocPlugin() {
    return new Plugin({
        appendTransaction: (transactions, oldState, newState) => {
            if (!transactions.some((transaction) => transaction.docChanged)) {
                // Do nothing if doc hasn't changed
                return null;
            }
            const { schema, doc } = newState;
            const tr = newState.tr;
            const docJsonContent = doc.toJSON().content;
            const toModify = [];
            const tocNodes = findChildrenByType(doc, schema.nodes.toc, true);
            tocNodes.forEach(({ node, pos }) => {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const nodeJSON = getTocJSON(docJsonContent, node.attrs.expanded);
                if (!isEqual(nodeJSON, node.toJSON())) {
                    const newNode = ProseMirrorNode.fromJSON(schema, nodeJSON);
                    toModify.push({ pos, node: newNode });
                }
            });
            // Sort by position descending to avoid invalidating positions
            toModify.sort((a, b) => b.pos - a.pos);
            toModify.forEach(({ pos, node }) => {
                // use tr.doc instead doc to account for previous transaction changes.
                const $pos = tr.doc.resolve(pos + 1);
                tr.replaceRangeWith($pos.start(), $pos.end(), node);
            });
            return toModify.length ? tr : null;
        },
    });
}
